<template>
  <div class="fullpage center">
    <div class="form-box">
      <a-alert v-if="error" :message="error" type="error"></a-alert>
      <a-form ref="fromLogin">
        <a-form-item label="Username or email">
          <a-input type="text" v-model="user.identifier" autocomplete="off"></a-input>
        </a-form-item>
        <a-form-item label="Password">
          <a-input
            type="password"
            v-model="user.password"
            autocomplete="off"
            @keyup.enter.exact.native="login()"
          ></a-input>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" :loading="isLoading" @click="login()">Login</a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      user: {
        identifier: "test",
        password: "test"
      },
      error: null
    };
  },
  methods: {
    login() {
      this.isLoading = true;
      this.error = false;

      this.$auth.login({
        data: {
          user: this.user
        },
        success: () => {
          this.isLoading = false;
        },
        error: request => {
          this.isLoading = false;
          this.error = request.response.data.message;
        },
        rememberMe: true,
        // redirect: false,
        fetchUser: true
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.form-box {
  width: 250px;
}
</style>

